export default "__VITE_ASSET__CNxSJeLK__"